/* __next_internal_client_entry_do_not_use__ CartItems auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1504))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:58.997Z
 */ export var CartItems = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M3.25598 14.7137H16.9703L18.6845 5.28516H1.85369C1.7285 5.28566 1.60494 5.31358 1.49169 5.36696C1.37845 5.42034 1.27827 5.49787 1.19821 5.59411C1.11814 5.69036 1.06013 5.80297 1.02825 5.92403C0.996375 6.0451 0.991404 6.17168 1.01369 6.29487L2.41598 14.0092C2.45162 14.2062 2.55515 14.3846 2.7086 14.5133C2.86204 14.642 3.0557 14.7129 3.25598 14.7137Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M18.688 5.28571L19.408 1.68571C19.4475 1.49211 19.5527 1.3181 19.7058 1.19315C19.8588 1.06819 20.0504 0.99996 20.248 1H22.9737",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M16.9739 14.7148L16.2556 18.3148C16.216 18.5087 16.1106 18.683 15.9572 18.808C15.8038 18.9329 15.6118 19.001 15.4139 19.0006H5.83105",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M5.83105 22.4294C5.83105 22.6567 5.92136 22.8748 6.08211 23.0355C6.24285 23.1962 6.46087 23.2866 6.6882 23.2866C6.91553 23.2866 7.13354 23.1962 7.29429 23.0355C7.45503 22.8748 7.54534 22.6567 7.54534 22.4294C7.54534 22.2021 7.45503 21.9841 7.29429 21.8233C7.13354 21.6626 6.91553 21.5723 6.6882 21.5723C6.46087 21.5723 6.24285 21.6626 6.08211 21.8233C5.92136 21.9841 5.83105 22.2021 5.83105 22.4294Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M13.5449 22.4294C13.5449 22.6567 13.6352 22.8748 13.796 23.0355C13.9567 23.1962 14.1747 23.2866 14.4021 23.2866C14.6294 23.2866 14.8474 23.1962 15.0082 23.0355C15.1689 22.8748 15.2592 22.6567 15.2592 22.4294C15.2592 22.2021 15.1689 21.9841 15.0082 21.8233C14.8474 21.6626 14.6294 21.5723 14.4021 21.5723C14.1747 21.5723 13.9567 21.6626 13.796 21.8233C13.6352 21.9841 13.5449 22.2021 13.5449 22.4294Z",
            fill: "currentColor",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M5.12451 8.88281V10.5971",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M13.6992 8.88281V10.5971",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M9.3999 8.88281V10.5971",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "CartItems", {
    viewBox: "0 0 24 24",
    titleAccess: "CartItems",
    fill: "none",
    color: Core.icon.default
});
